/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Box, Button, CircularProgress, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, useMediaQuery } from "@mui/material";
import { useTheme } from "@emotion/react";
import Popup from "../../components/popups/popup";
import { useParams } from "react-router-dom";
import { formatPrice } from "../../utils";
import PagePaymentService from "../../services/pagePaymentService";
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import AddIcon from '@mui/icons-material/Add';
import DeletePostPagePaymentModal from "../../components/modals/pagePayment/deletePostPagePaymentModal";
import AddPostPagePaymentModal from "../../components/modals/pagePayment/addPostPagePaymentModal";

const UpdatePagePayment = () => {
    const { t, i18n } = useTranslation();
    const theme = useTheme();
    const isTablet = useMediaQuery(theme.breakpoints.down('md'));
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const isEn = i18n.language === 'en';
    const tableHeadingStyle = { fontWeight: 'bold', backgroundColor: theme.palette.customGrey.pdfTable };

    const { id } = useParams();

    const [pagePayment, setPagePayment] = useState({});
    const [openDelete, setOpenDelete] = useState(false);
    const [openAdd, setOpenAdd] = useState(false);
    const [selectedPost, setSelectedPost] = useState({});

    const [isModalLoading, setIsModalLoading] = useState(true);

    const [showPopup, setShowPopup] = useState(false);
    const [popupMsg, setPopupMsg] = useState(false);
    const [popupType, setPopupType] = useState(false);

    const handleOpenDelete = (post) => {
        setSelectedPost(post);
        setOpenDelete(true);
    };
    const handleCloseDelete = async ({ isReaload }) => {
        setOpenDelete(false);
        if (isReaload) {
            await fetchPagePayment();
        }
    };

    const handleOpenAdd = () => {
        setOpenAdd(true);
    };
    const handleCloseAdd = async ({ isReaload }) => {
        setOpenAdd(false);
        if (isReaload) {
            await fetchPagePayment();
        }
    };


    const fetchPagePayment = async () => {
        try {
            const data = await PagePaymentService.fetchOne(id);
            setPagePayment(data);
            setIsModalLoading(false);
        } catch (error) {
            console.error('Error fetching page:', error);
        }
    };

    useEffect(() => {

    }, [pagePayment]);


    useEffect(() => {
        setIsModalLoading(true);
        fetchPagePayment();
    }, []);



    return (
        <Box sx={{
            p: isTablet ? 1 : 2,
            backgroundColor: theme.palette.secondary.main,
        }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <DeletePostPagePaymentModal open={openDelete} handleClose={handleCloseDelete} setPopupMsg={setPopupMsg}
                    setPopupType={setPopupType}
                    setShowPopup={setShowPopup} post={selectedPost} paymenetId={id} />

                <AddPostPagePaymentModal open={openAdd} handleClose={handleCloseAdd} setPopupMsg={setPopupMsg}
                    setPopupType={setPopupType}
                    setShowPopup={setShowPopup} pagePayment={pagePayment} />
            </Box>
            {showPopup && (
                <Popup
                    text={popupMsg}
                    type={popupType}
                    onClose={() => setShowPopup(false)}
                />
            )}
            <Box
                sx={{
                    width: '100%',
                    bgcolor: 'background.paper',
                    borderRadius: 2,
                    border: 1,
                    borderColor: theme.palette.customGrey.borderInput,
                    p: isTablet ? 1 : 4
                }}
            >
                {
                    isModalLoading ? <Box sx={{ justifyContent: 'center', display: 'flex', my: 10 }} >
                        <CircularProgress color="primary" size={28} />
                    </Box>
                        : <Box>
                            <Box sx={{
                                display: 'flex',
                                justifyContent: 'space-between'
                            }}>
                                <Typography id="transition-modal-title" variant="h6" component="h2">
                                    {t('updatePagePayment')}
                                </Typography>
                            </Box>

                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: isMobile ? 'column' : 'row',
                                    gap: 1,
                                    padding: '12px',
                                    backgroundColor: theme.palette.customGrey.pdfTable,
                                    borderRadius: 1,
                                    border: 1,
                                    borderColor: theme.palette.customGrey.borderInput,
                                    my: 2
                                }}
                            >
                                <Box width={isMobile ? '100%' : '50%'}>
                                    <Typography variant="body1" sx={{}}>
                                        {t('id')}: <span style={{ fontWeight: 'bold' }}>{pagePayment.id}</span>
                                    </Typography>

                                    <Typography variant="body1" sx={{ mt: 2 }}>
                                        {t('pageName')}: <span style={{ fontWeight: 'bold' }}>{pagePayment.page && pagePayment.page.name}</span>
                                    </Typography>

                                    <Typography variant="body1" sx={{ mt: 2 }}>
                                        {t('priceAmount')}: <span style={{ fontWeight: 'bold' }}>{formatPrice(pagePayment.priceAmount)}</span>
                                    </Typography>

                                    <Typography variant="body1" sx={{ mt: 2 }}>
                                        {t('totalPrice')}: <span style={{ fontWeight: 'bold' }}>{formatPrice(pagePayment.totalPrice)}</span>
                                    </Typography>

                                </Box>

                                {/* col 2 */}
                                <Box width={isMobile ? '100%' : '50%'}>
                                    <Typography variant="body1" sx={{}}>
                                        {t('branch')}: <span style={{ fontWeight: 'bold' }}>{pagePayment.branch && pagePayment.branch.name}</span>
                                    </Typography>

                                    <Typography variant="body1" sx={{ mt: 2 }}>
                                        {t('user')}: <span style={{ fontWeight: 'bold' }}>{pagePayment.user && pagePayment.user.name}</span>
                                    </Typography>

                                    <Typography variant="body1" sx={{ mt: 2 }}>
                                        {t('createdAt')}: <span style={{ fontWeight: 'bold' }}>{pagePayment.createdAt}</span>
                                    </Typography>

                                    <Typography variant="body1" sx={{ mt: 2 }}>
                                        {t('transportationPrice')}: <span style={{ fontWeight: 'bold' }}>{formatPrice(pagePayment.transportationPrice)}</span>
                                    </Typography>
                                </Box>

                            </Box>

                            <TableContainer
                                component={Paper}
                                // ref={tableContainerRef}
                                id="tableContainer"
                                sx={{
                                    boxShadow: 'none',
                                    border: 1,
                                    borderColor: theme.palette.customGrey.borderInput,
                                    borderRadius: 2,
                                    height: 'calc(100vh - 450px)',
                                    overflowY: 'auto',
                                    width: '100%',
                                }}
                            >
                                <Table stickyHeader aria-label="simple table">
                                    <TableHead
                                        sx={{
                                            position: 'sticky',
                                            top: 0,
                                            zIndex: 1
                                        }}
                                    >
                                        <TableRow>
                                            <TableCell align={isEn ? 'left' : 'right'} sx={tableHeadingStyle}>
                                                {t('number')}
                                            </TableCell>

                                            <TableCell align={isEn ? 'left' : 'right'} sx={tableHeadingStyle}>
                                                {t('id')}
                                            </TableCell>

                                            <TableCell align={isEn ? 'left' : 'right'} sx={tableHeadingStyle}>
                                                {t('invoiceNumber')}
                                            </TableCell>

                                            <TableCell align={isEn ? 'left' : 'right'} sx={tableHeadingStyle}>
                                                {t('receiverPhone')}
                                            </TableCell>

                                            <TableCell align={isEn ? 'left' : 'right'} sx={tableHeadingStyle}>
                                                {t('address')}
                                            </TableCell>

                                            <TableCell align={isEn ? 'left' : 'right'} sx={tableHeadingStyle}>
                                                {t('totalPrice')}
                                            </TableCell>

                                            <TableCell align={isEn ? 'left' : 'right'} sx={tableHeadingStyle}>
                                                {t('transportationPrice')}
                                            </TableCell>

                                            <TableCell align={isEn ? 'left' : 'right'} sx={tableHeadingStyle}>
                                                {t('netPrice')}
                                            </TableCell>

                                            <TableCell align={isEn ? 'left' : 'right'} sx={tableHeadingStyle}>
                                                {t('actions')}
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {pagePayment.posts.map((post, index) => (
                                            <TableRow
                                                key={post.id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                <TableCell align={isEn ? 'left' : 'right'} component="th" scope="row">{index + 1}</TableCell>
                                                <TableCell align={isEn ? 'left' : 'right'}>{post.id}</TableCell>
                                                <TableCell align={isEn ? 'left' : 'right'}>{post.invoiceNumber}</TableCell>
                                                <TableCell align={isEn ? 'left' : 'right'}>{post.receiverPhone}</TableCell>
                                                <TableCell align={isEn ? 'left' : 'right'}>{post.receiverAddress}, {post.street.name}, {post.street.city.name}</TableCell>
                                                <TableCell align={isEn ? 'left' : 'right'}>{formatPrice(post.totalPrice)}</TableCell>
                                                <TableCell align={isEn ? 'left' : 'right'}>{formatPrice(post.transportationPrice)}</TableCell>
                                                <TableCell align={isEn ? 'left' : 'right'}>{formatPrice(post.netPrice)}</TableCell>
                                                <TableCell align={isEn ? 'left' : 'right'}>
                                                    <Box sx={{
                                                        display: 'inline-flex',
                                                        border: 1,
                                                        borderColor: theme.palette.customGrey.borderInput,
                                                        backgroundColor: theme.palette.secondary.main,
                                                        borderRadius: 1,
                                                    }}>
                                                        <Box sx={{
                                                            px: 1.5,
                                                            pt: 0.6,
                                                            pb: 0.25,
                                                            cursor: 'pointer',
                                                            pointerEvents: 'auto',
                                                            opacity: 1,
                                                        }} onClick={() => handleOpenDelete(post)}>
                                                            <DeleteOutlineOutlinedIcon fontSize='small'
                                                                sx={{ color: theme.palette.red.bg }}
                                                            />
                                                        </Box>
                                                    </Box>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>

                            <Box sx={{
                                display: 'flex', justifyContent: 'center', alignItems: 'center',
                                mt: 3
                            }}>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    color="primary"
                                    sx={{ textTransform: 'none', width: 140, height: 40 }}
                                    onClick={() => handleOpenAdd()}
                                >
                                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                        <p>{t('add')}</p>
                                        <AddIcon fontSize="small" sx={{ mx: 0.4 }} />
                                    </Box>
                                </Button>
                            </Box>
                        </Box>
                }

            </Box>
        </Box>
    );
}

export default UpdatePagePayment;